import { useState, useEffect } from "react"

function Slider() {

    const images = [
        {
            currentIndex: 0,
            desc: 'Concerti Tribute Band',
            nome: 'lukas-eggers-aYttBtAu7zg-unsplash_compress.webp'
        },
        {
            currentIndex: 1,
            desc: "Autoraduni d'epoca",
            nome: 'liz-fitch-w3JCvme6sSo-unsplash_compress.webp'
        },
        {
            currentIndex: 2,
            desc: "Fiere enogastronomiche",
            nome: 'jason-ng-ZyvnSOxQc2A-unsplash_compress.webp'
        },
        {
            currentIndex: 3,
            desc: "Eventi per bambini",
            nome: 'samuel-lopez-cruz-3XoJjUbsRNo-unsplash_compress.webp'
        },
        {
            currentIndex: 4,
            desc: "Eventi Fashion",
            nome: 'dominik-kielbasa-ssnCzNayHC4-unsplash_compress.webp'
        },
        {
            currentIndex: 5,
            desc: "Feste a tema",
            nome: 'evgeny-strzhalkovsky-mB9LDnJq7g4-unsplash_compress.webp'
        },
        {
            currentIndex: 6,
            desc: "Mercatini",
            nome: 'annie-spratt-kr_88BakygA-unsplash_compress.webp'
        },
        {
            currentIndex: 7,
            desc: "Luna Park",
            nome: 'gabriel-sollmann-jM1kROWzfQU-unsplash_compress.webp'
        },
        {
            currentIndex: 8,
            desc: "Motoraduni",
            nome: 'jeff-cooper-bfAY6fzuZyc-unsplash_compress.webp'
        },
        {
            currentIndex: 9,
            desc: "Mercatini Natalizi",
            nome: 'humphrey-m-ANJXCtMbDfA-unsplash_compress.webp'
        },
        {
            currentIndex: 10,
            desc: "Eventi Sportivi",
            nome: 'markus-spiske-WUehAgqO5hE-unsplash_compress.webp'
        },
    ]
    const [currentIndex, setCurrentIndex] = useState(0)

    const nextSlide = () => {// Funzione per andare alla slide successiva
        const reg = document.getElementById('slide').style
        reg.transition = 'opacity 1.5s'; reg.opacity = '0'
        setTimeout(() => {
            setCurrentIndex((prevIndex) =>
                prevIndex === images.length - 1 ? 0 : prevIndex + 1
            )
            reg.transition = 'opacity 1.5s'; reg.opacity = '1'
        }, 1000)
    }

    const goToSlide = (index) => {// Funzione per andare a una slide specifica (cliccando i puntini)
        setCurrentIndex(index)
    }

    useEffect(() => {// useEffect per lo scorrimento automatico (AutoPlay)
        const interval = setInterval(() => {
            nextSlide()
        }, 3000) // Cambia immagine ogni 3 secondi

        // Pulizia dell'intervallo per evitare memory leak
        return () => clearInterval(interval)
    }, [currentIndex])

    return (<>
        <div style={{ marginBottom: '3em' }} className="iconChatMobile">
            <div style={{ textAlign: 'center', display: 'inline-block', width: '100%', position: 'relative' }} id="slide">
                
                <img src={`https://leuro-bucket.s3.amazonaws.com/slider/${images[currentIndex].nome}`} className='slider' />
                <p className="fs-4" style={{ position: 'absolute', left: '0', right: '0', display: 'flex', justifyContent: 'center', 
                    color: 'white', backgroundColor: 'dimgrey' }}>
                    {images[currentIndex].desc}
                </p>
            </div>

            {/* Indicatori (Dots) */}
            <div style={{ textAlign: 'center', marginTop: '2em' }}>
                {images.map((_, index) => (
                    <span
                        key={index}
                        className={`${currentIndex === index ? 'dotactive' : ''}`}
                        onClick={() => goToSlide(index)}
                        style={{ borderRadius: '50%', border: '1px solid grey', margin: '6px', fontSize: '8px', color: 'transparent', cursor: 'pointer' }}
                    >......</span>
                ))}
            </div>
        </div>
    </>)
}
export default Slider